export const SECURITY_AUTH = "SECURITY_AUTH";
export const ADD_NOTIFICATION = "addInformation";
export const PUSH_NOTIFICATION = "pushNotification";
